import { useContextState } from "../../../../../../../../../../hooks/theme"



const useStyles = () => {
  const { colors } = useContextState()
  const sharedStyles = {
    squareButton: {
      color: colors.color5,
      borderRadius: '5px',
      boxShadow: `1px 1px 2px ${colors.color10}`,
      padding: '12px',
      background: colors.color30,
      '&:hover': {
        background: colors.color30 + 'dd',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.7rem',
      },
      /* marginBottom: '2px', */
    },
  }
  return {
    title: {
      flexGrow: 1,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '40px'
    },
    body: {
      paddingRight: 3,
      '& .mb': {
        marginBottom: '16px'
      }
    },
    containerTitle: (isFree:boolean) => ({
      marginBottom: isFree ? '16px':'0px'
    }),
    containerDate: {
      display: 'flex',
      gap: '20px',
      padding: '16px 0px'
    },
    badge: {
      '& .MuiBadge-badge': {
        background: colors.color20,
        color: colors.color25,
      },
    },
    clip: (disable:boolean) => ({
      color: colors.color5,
      borderRadius: '5px',
      boxShadow:disable ? '':`1px 1px 2px ${colors.color10}`,
      padding: '12px',
      background: colors.color30,
      '&:hover': {
        background: colors.color30 + 'dd',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.7rem',
      },
    }),
    containerClip: {
      paddingTop: '5px'
    }
  }
}

export { useStyles }